import React, { useState, useEffect, useRef } from "react";
import {
  NavigationBackground,
  NavigationLink,
  NavigationLinkRed,
  NavScrollLink,
  NavigationList,
  NavigationLogo,
  NavigationLogoLink,
  NavigationLogoScrollLink,
  Dragon,
  StyledFlagToggle,
  IconBody,
  ModeChange,
  FlagIconBody,
  Body,
  DarkMode,
  StyledSunIcon,
  StyledDragonIcon,
  ProfileImage,
  PremiumBadge2,
  ProfileMenuWrapper,
  ProfileMenu,
  ProfileMenuHeader,
  ProfileMenuImage,
  ProfileMenuName,
  ProfileMenuItem,
  ProfileMenuDivider,
  TokensContainer,
  TokensIcon,
  TokensValue,
  SubscriptionBadge,
} from "./styled";
import { NavLink } from "react-router-dom";
import logoTransparent from "../Assets/LogoForBright.png";
import logo from "../Assets/LogoForDark.png";
import { useSelector, useDispatch } from "react-redux";
import {
  selectIsLightMode,
  selectTilesDetails,
  selectRestrictedDataError,
  selectOpenAiTokens,
  selectActiveSubscription,
} from "../../../mainApp/features/DataSlice/dataSlice";
import { useLocation } from "react-router-dom";
import { selectIsNoon } from "../../../mainApp/features/DataSlice/dataSlice";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import ImageSkeleton from "../UiComponents/ImageSkeleton";
import { setOpenAiTokens } from "../../../mainApp/features/DataSlice/dataSlice";
import { FaCoins } from "react-icons/fa";

const NavigationBar = ({ isLoading }) => {
  const location = useLocation();
  const isInMain = location.pathname === "/";
  const dispatch = useDispatch();
  const siteTheme = useSelector(selectIsLightMode);
  const [prevScrollpos, setPrevScrollpos] = useState(window.scrollY);
  const [visible, setVisible] = useState(true);
  const noonMode = useSelector(selectIsNoon);
  const [user, setUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [userName, setUserName] = useState("");
  const [userSurname, setUserSurname] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true); // Nowy stan dla skeletona
  const menuRef = useRef(null);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const openAiTokens = useSelector(selectOpenAiTokens); // Pobranie tokenów
  const activeSubscription = useSelector(selectActiveSubscription);

  const getPlanName = () => {
    if (!activeSubscription || !activeSubscription.priceId) {
      return null;
    }
    const standardPlans = [
      process.env.REACT_APP_STANDARD_MONTHLY,
      process.env.REACT_APP_STANDARD_YEARLY,
    ];
    const premiumPlans = [
      process.env.REACT_APP_PREMIUM_MONTHLY,
      process.env.REACT_APP_PREMIUM_YEARLY,
    ];

    if (standardPlans.includes(activeSubscription.priceId)) {
      return { name: "Standard", isPremium: false };
    }
    if (premiumPlans.includes(activeSubscription.priceId)) {
      return { name: "Premium", isPremium: true };
    }
    return null;
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      setUser(currentUser);
      if (currentUser && currentUser.emailVerified) {
        const docRef = doc(db, "Users", currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setUserDetails(data);
          // Ustawiamy tokeny w Redux zaraz po pobraniu danych
          dispatch(setOpenAiTokens(data.openAiTokens || 0));
          setImageSrc(data.photo || require("../Assets/jakub.png")); // Tylko userPhoto, bez jakub.png
          setUserName(data.firstName || "Użytkownik");
          setUserSurname(data.lastName || "");
          // Opóźnienie ukrycia skeletona o 1 sekundę
          setTimeout(() => {
            console.log("Hiding skeleton after 1s delay");
            setShowSkeleton(false);
          }, 1000);
        } else {
          console.warn("Dokument użytkownika nie istnieje.");
          setImageSrc(require("../Assets/jakub.png")); // Skeleton, bez jakub.png
          setUserName("Użytkownik");
          setUserSurname("");
          // Pokazuj skeleton, jeśli brak danych
          setShowSkeleton(true);
        }
      } else {
        // Użytkownik się wylogował - wyczyść wszystkie dane
        setUserDetails(null);
        setImageSrc(null);
        setUserName("");
        setUserSurname("");
        setShowSkeleton(false);
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(prevScrollpos > currentScrollPos || currentScrollPos < 10);
      setPrevScrollpos(currentScrollPos);
      if (isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollpos, isMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const getBackgroundColor = () => {
    if (prevScrollpos <= 140) {
      return "transparent";
    } else {
      return "#191414";
    }
  };

  const getFontColor = () => {
    if (prevScrollpos <= 320 && siteTheme) {
      return "#202638";
    } else {
      return "#CCCCCC";
    }
  };

  const toggleMenu = () => {
    console.log("toggleMenu called, isMenuOpen:", !isMenuOpen);
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = (action) => {
    setTimeout(() => {
      setIsMenuOpen(false);
    }, 100);
    if (action) action();
  };

  const logoOnlyPaths = [
    "/404",
    "/unauthorized",
    "/profile",
    "/register",
    "/login",
    "/reset-password",
    "/email-verification",
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/pricing"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/policy"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/regulations"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/home"] : []),
    ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/profilePage"] : []),
     ...(tilesDetails.length === 0 && restrictedDataError || !user || !userDetails ? ["/info"] : []),
  ];

  const renderLogo = () => (
    <>
      {isInMain ? (
        <NavigationLogoScrollLink
          activeClass="active"
          to="AboutMeSection"
          spy={true}
          smooth={false}
          offset={-270}
          duration={650}
          isLoading={isLoading}
        >
          <NavigationLogo>
            {prevScrollpos <= 320 ? (
              <Dragon src={logo} width="210" isLoading={isLoading} />
                            // siteTheme ? logoTransparent : 
            ) : (
              <Dragon src={logo} width="210" isLoading={isLoading} />
                            // siteTheme ? logoTransparent : 
            )}
          </NavigationLogo>
        </NavigationLogoScrollLink>
      ) : (
        <NavigationLogoLink to="/login" isLoading={isLoading}>
          <NavigationLogo>
            {prevScrollpos <= 320 ? (
              <Dragon src={logo} width="210" isLoading={isLoading} />
            ) : (
              <Dragon src={logo} width="210" isLoading={isLoading} />
            )}
          </NavigationLogo>
        </NavigationLogoLink>
      )}
    </>
  );

  return (
    <NavigationBackground
      visible={visible}
      style={{ backgroundColor: getBackgroundColor() }}
    >
      <NavigationList>
        {logoOnlyPaths.includes(location.pathname) ? (
          renderLogo()
        ) : (
          <>
            {renderLogo()}
            <ModeChange>
              {getPlanName() && (
                <SubscriptionBadge isPremium={getPlanName().isPremium}>
                  {getPlanName().name}
                </SubscriptionBadge>
              )}
              <TokensContainer>
                <TokensIcon>
                  <FaCoins />
                </TokensIcon>
                <TokensValue>{openAiTokens}</TokensValue>
              </TokensContainer>
              <IconBody onClick={() => dispatch({ type: "CHANGE_THEME" })} $themes={siteTheme} isLoading={isLoading}>
                <Body>
                  <StyledDragonIcon $themes={siteTheme} />
                </Body>
                <PremiumBadge2 isAi>smoki-WKRÓTCE</PremiumBadge2>
              </IconBody>
              <DarkMode></DarkMode>
              <IconBody onClick={() => dispatch({ type: "CHANGE_THEME" })} $themes={siteTheme} isLoading={isLoading}>
                <Body>
                  <StyledSunIcon $themes={siteTheme} />
                </Body>
                <PremiumBadge2 isAi>tryb jasny-WKRÓTCE</PremiumBadge2>
              </IconBody>
              <DarkMode></DarkMode>
              <ProfileMenuWrapper ref={menuRef} isLoading={isLoading}>
                <div
                  style={{ position: "relative", width: "36px", height: "36px", cursor: "pointer" }}
                  onClick={toggleMenu}
                >
                  <ImageSkeleton
                    width="38px"
                    height="38px"
                    hidden={!showSkeleton}
                  />
                  {imageSrc && (
                    <ProfileImage
                      src={imageSrc || require("../Assets/jakub.png")}
                      alt="Profile"
                      isSkeletonVisible={showSkeleton} // Przekazanie stanu skeletona
                      onLoad={() => {
                        console.log("ProfileImage loaded:", imageSrc);
                      }}
                    />
                  )}
                </div>
                <ProfileMenu isOpen={isMenuOpen}>
                  <ProfileMenuHeader>
                    <div style={{ position: "relative", width: "32px", height: "32px", marginRight: "12px" }}>
                      {imageSrc && !showSkeleton ? (
                        <ProfileMenuImage
                          src={imageSrc || require("../Assets/jakub.png")}
                          alt="Profile"
                        />
                      ) : (
                        <ImageSkeleton
                          width="34px"
                          height="34px"
                          hidden={false}
                        />
                      )}
                    </div>
                    <ProfileMenuName>{userName} {userSurname}</ProfileMenuName>
                  </ProfileMenuHeader>
                  <ProfileMenuItem to="/profilePage" onClick={() => handleMenuItemClick()}>
                    Twój profil
                  </ProfileMenuItem>
                  <ProfileMenuItem to="/settings" onClick={() => handleMenuItemClick()}>
                    Ustawienia
                  </ProfileMenuItem>
                  <ProfileMenuDivider />
                  <ProfileMenuItem to="/pricing" onClick={() => handleMenuItemClick()}>
                    Plany i ceny
                  </ProfileMenuItem>
                  <ProfileMenuItem to="/regulations" onClick={() => handleMenuItemClick()}>
                    Regulamin
                  </ProfileMenuItem>
                  <ProfileMenuItem to="/policy" onClick={() => handleMenuItemClick()}>
                    Polityka
                  </ProfileMenuItem>
                  <ProfileMenuItem to="/login" onClick={() => handleMenuItemClick(() => auth.signOut())}>
                    Wyloguj się
                  </ProfileMenuItem>
                </ProfileMenu>
              </ProfileMenuWrapper>
            </ModeChange>
          </>
        )}
      </NavigationList>
    </NavigationBackground>
  );
};

export default NavigationBar;